import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId })
      .then(({ data }) => navigate("/account", { replace: true, state: { user: data } }))
      .catch(() => navigate("/", { replace: true }));
  }, [location, navigate]);

  return (
    <main className="min-h-screen bg-cream flex items-center justify-center" data-testid="auth-callback">
      <Loader2 className="animate-spin text-gold" size={32} strokeWidth={1.5} />
    </main>
  );
}
